export const ARTICLE_COLOR_PALETTE = [
  0x2266ee, 0xffcc00, 0xdd0099, 0x00aa33, 0x8844ff, 0x00b3c2, 0xe61919, 0xa3d11a, 0xeeaaff,
  0xdd55ff, 0xff7788, 0x7799ff,
]

export function articleColorCss(index: number): string {
  const hex = ARTICLE_COLOR_PALETTE[index % ARTICLE_COLOR_PALETTE.length]
  return '#' + hex.toString(16).padStart(6, '0')
}

export function articleColorIndexFor(articleNumber: string): number {
  let hash = 0
  for (let i = 0; i < articleNumber.length; i++) {
    hash = (hash * 31 + articleNumber.charCodeAt(i)) | 0
  }
  return Math.abs(hash) % ARTICLE_COLOR_PALETTE.length
}

export function moduleArticleColorMap(stepsInOrder: string[][]): Map<string, number> {
  const paletteSize = ARTICLE_COLOR_PALETTE.length
  const map = new Map<string, number>()
  const usage = new Array<number>(paletteSize).fill(0)

  for (const stepArticles of stepsInOrder) {
    const unique = [...new Set(stepArticles)].sort()
    const takenInStep = new Set(unique.flatMap((n) => (map.has(n) ? [map.get(n)!] : [])))
    for (const articleNumber of unique) {
      if (map.has(articleNumber)) continue
      const free = [...usage.keys()].filter((i) => !takenInStep.has(i))
      const candidates = free.length > 0 ? free : [...usage.keys()]
      const index = candidates.reduce((best, i) => (usage[i] < usage[best] ? i : best))
      map.set(articleNumber, index)
      usage[index]++
      takenInStep.add(index)
    }
  }
  return map
}

export function sameColorMap(a: Map<string, number>, b: Map<string, number>): boolean {
  if (a.size !== b.size) return false
  for (const [articleNumber, index] of a) {
    if (b.get(articleNumber) !== index) return false
  }
  return true
}
